import Form from "react-bootstrap/Form";
import "../../../../src/main.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "modules/utilities/utility";

function RevenueFilter(props) {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [newDate , setNewDate]=useState(new Date);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate(null);
  };
  const handleResetEndDate = () => {
    setEndDate(null);
  };

  // const formatDate = (date) => {
  //   return format(date, "yyyy-MM-dd");
  // };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    const formattedStartDate = startDate ? formatDate(startDate) : null;
    const formattedEndDate = endDate ? formatDate(endDate) : null;
    props.setStartDateFilter(formattedStartDate);
    props.setEndDateFilter(formattedEndDate);
    props.setDateFilter(false);
  };

  const handleClearData = () => {
    props.setDateFilter(true);
    setStartDate(new Date());
    setEndDate(new Date());
    setNewDate(new Date());
  };

  return (
    <>
      <Form onSubmit={handleFilterSubmit} className="data-filter">
        <div className="d-flex gap-2">
          <Form.Group>
            <div className="input-container mt-1">
              {startDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={newDate}
                onChange={handleStartDateChange}
                placeholderText="Start Date"
                dateFormat="dd-MM-yyyy"
                value={startDate ? formatDate(startDate) : ""}
                className="input-with-icon"
              />
              {startDate && (
                <span className="reset-icon" onClick={handleResetStartDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <div className="input-container mt-1">
              {endDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={newDate}
                onChange={handleEndDateChange}
                placeholderText="End Date"
                dateFormat="dd-MM-yyyy"
                value={endDate ? formatDate(endDate) : ""}
              />
              {endDate && (
                <span className="reset-icon" onClick={handleResetEndDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>
          <div className="d-flex gap-2">
            <Button variant="primary" className="mt-1" type="submit">
              Apply
            </Button>
            <Button
              variant="primary"
              className="mt-1"
              onClick={handleClearData}
            >
              Clear
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
}

export default RevenueFilter;
